module.exports = __webpack_public_path__ + "img/62.30035bec.png";